import React, { useEffect, useState } from 'react';
export function StickyNav() {
  const [isVisible, setIsVisible] = useState(true);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Keep banner visible at all times
      setIsVisible(true);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const copyDiscountCode = () => {
    navigator.clipboard.writeText('stresslessdogs');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <button onClick={copyDiscountCode} className={`fixed top-0 left-0 right-0 z-50 w-full bg-gradient-to-r from-[rgb(var(--color-primary))] to-emerald-600 text-white shadow-lg transition-all duration-300 hover:opacity-95 cursor-pointer ${isVisible ? 'translate-y-0' : '-translate-y-full'}`} data-id="element-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3" data-id="element-301">
        {copied ? <p className="text-sm sm:text-base font-semibold text-center animate-pulse" data-id="element-302">
            ✓ Vouchercode gekopieerd!
          </p> : <p className="text-sm sm:text-base font-semibold text-center" data-id="element-303">
            ✨ Speciale aanbieding: Ontvang vandaag 10% welkomstkorting op uw
            eerste bestelling met code:{' '}
            <span className="bg-white/20 px-3 py-1 rounded-md font-bold mx-1" data-id="element-304">
              stresslessdogs
            </span>{' '}
            ✨
          </p>}
      </div>
    </button>;
}